
export const defaultAccentColor = '#4ee100'
export const defaultBackgroundColor = '#292929'

export const accentQueryKey = 'accent'
export const backgroundQueryKey = 'background'